function izipush(title,text,color,position='topRight',timeout=5000) {
    iziToast.show({
        title: title,
        message: text,
        color: color, // blue, red, green, yellow
        position: position, // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter, center
        timeout: timeout,
        displayMode: 2,
        onOpening: function(){
            notifSound(color);
        }
    });
}

function notifSound(color){
    var audio = new Audio(); // Создаём новый элемент Audio
    audio.volume = 0.3;
    if(color==="red"){
        audio.src = location.origin+'/assets/files/sound/error.mp3'; // Указываем путь к звуку "клика"
        audio.autoplay = true; // Автоматически запускаем
        audio.autoplay;
    }
}
$(document).ready(function(){
    //
});
